import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-health-check',
  templateUrl: './health-check.component.html',
  styleUrls: []
})
export class HealthCheckComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
